import moment from "moment"

import { ICardContractTabPrimary } from "./types"
import { getContractGuardianAddressSuggestions } from "@api/contracts/api"
import CommonService from "@services/common.service"

import imgEmty from '@img/empty.svg'
import { IconAdd, IconDelete, IconListeners, IconUpdate } from "@img/icons"

import { Empty, Flex, Textarea, Input, Divider, Button, Table, Toogle, Container } from "@ui/index"
import css from './ui.module.scss'
import { SelectDate } from "@primitive/calendar"
import { getInputButton } from "@primitive/getInputButton"
import { DictSelectorContainer } from "@smart/dictSelector"
import { ListenerAddressInput } from "@smart/listenerAddressInput"


/** Вкладка основная */
export const CardContractTabPrimary = ({
    cardMode, fieldsError, summDuty, paymentsList, programsList, txtPostPayment, txtOutsideMoodle, 
    txtApplicationID, txtContractDate, txtContractNumber, txtContractTypeID, txtContractType, txtContractView, txtContractStatus,
    txtCompanyINN, txtCompanyName, txtCompanyContactFIO, txtCompanyContactPhone, txtCompanyContactEmail, txtComment,
    guardianRequired, txtGuardianBirthDate, txtGuardianLastName, txtGuardianFirstName, txtGuardianSecondName,
    txtGuardianPassport, txtGuardianRegistrationAddress,
    
    handlerOpenModalConfirm, dictSelectorData, handlerOpenModalProgram, handlerOpenModalCompanies, handlerOpenModalListeners,
    handlerOpenModalListenerProperty, handlerOpenModalPayments,
}: ICardContractTabPrimary) => {
    const formatter = new Intl.NumberFormat('ru-RU')

    return <>
        <Flex gap="20px">
            <Flex gap="5px">
                <Divider gap='6px' prefix={<h4>Параметры</h4>} />

                <Flex gap='15px'>
                    <Flex gap="15px" flexDirection="row" justifyContent="flex-start" flexWrap="wrap">
                        <Container type='secondary' padding='6px 6px 6px 10px' className={css['container_toggle']}>
                            <p>Постоплата:</p>
                            <Toogle checked={txtPostPayment.value === 1} onChange={() => txtPostPayment.setValue(txtPostPayment.value === 1 ? 0 : 1)} />
                        </Container>

                        <Container type='secondary' padding='6px 6px 6px 10px' className={css['container_toggle']}>
                            <p>Обучение вне LMS:</p>
                            <Toogle checked={txtOutsideMoodle.value === 1} onChange={() => txtOutsideMoodle.setValue(txtOutsideMoodle.value === 1 ? 0 : 1)} />
                        </Container>
                    </Flex>
                </Flex>
            </Flex>

            <Flex gap="5px">
                <Divider gap='6px' prefix={<h4>Основная информация</h4>} />

                <Flex gap='15px'>
                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' isRendered={cardMode === 'new'} className={!fieldsError.value.applicationID ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Номер заявки <p className="pulse"></p></Flex>
                            <Input placeholder="Номер заявки" isReadOnly {...txtApplicationID}
                                suffix={
                                    <DictSelectorContainer dictName="applicationsNumber" 
                                        onSelect={(data) => {
                                            dictSelectorData('applicationsNumber', data)
                                        }}
                                    >{getInputButton('select')}</DictSelectorContainer>
                                }  
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.contractDate ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Дата договора <p className="pulse"></p></Flex>
                            
                            <Input placeholder="Дата договора" type='mask' mask='99.99.9999' {...txtContractDate}
                                suffix={
                                    <SelectDate currentDate={txtContractDate.value} onSelect={(date) => { txtContractDate.setValue(date) }}>
                                        {getInputButton('calendar')}
                                    </SelectDate>
                                }
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' isRendered={cardMode === 'edit'} className={!fieldsError.value.contractNumber ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Номер договора <p className="pulse"></p></Flex>
                            <Input placeholder="Номер договора" isReadOnly {...txtContractNumber} 
                                suffix={<Button id="tooltipBtnGenContractNumber" size="sm" variant="iconInput"
                                    onClick={() => handlerOpenModalConfirm(true, 'Номер договора', 'Вы действительно хотите сгененировать новый номер, для данного договора?', 'contractNumber')}><IconUpdate />
                                </Button>}
                            />
                        </Flex>
                    </Flex>

                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.contractType ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Тип договора <p className="pulse"></p></Flex>
                            <Input placeholder="Тип договора" isReadOnly {...txtContractType}
                                suffix={
                                    <DictSelectorContainer isScroll={false} isSearch={false} dictName="contractType" 
                                        onSelect={(data) => {
                                            dictSelectorData('contractType', data)
                                        }}
                                    >{getInputButton('select')}</DictSelectorContainer>
                                }  
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' isRendered={txtContractTypeID.value !== 1} className={!fieldsError.value.contractView ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Вид договора <p className="pulse"></p></Flex>
                            <Input placeholder="Вид договора" isReadOnly {...txtContractView}
                                suffix={
                                    <DictSelectorContainer isScroll={false} isSearch={false} dictName="contractView" 
                                        onSelect={(data) => {
                                            dictSelectorData('contractView', data)
                                        }}
                                    >{getInputButton('select')}</DictSelectorContainer>
                                }  
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.contractStatus ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Статус договора <p className="pulse"></p></Flex>
                            <Input placeholder="Статус договора" isReadOnly {...txtContractStatus}
                                suffix={
                                    <DictSelectorContainer isScroll={false} isSearch={false} dictName="contractStatus" 
                                        onSelect={(data) => {
                                            dictSelectorData('contractStatus', data)
                                        }}
                                    >{getInputButton('select')}</DictSelectorContainer>
                                }  
                            />
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>

            <Flex gap="5px" isRendered={txtContractTypeID.value !== 1}>
                <Divider gap='6px' prefix={<h4>Юридическое лицо</h4>} />

                <Flex gap='15px'>
                    <div className={css['company_identity_row']}>
                        <Flex>
                            <Flex flexDirection="row" className="input_header">ИНН Контрагента</Flex>
                            <Input placeholder="ИНН Контрагента" isReadOnly {...txtCompanyINN} />
                        </Flex>

                        <Flex className={`${css['company_name_field']} ${!fieldsError.value.companyName ? 'input_error' : 'input_error input_error-active'}`}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Наименование контрагента <p className="pulse"></p></Flex>
                            <Input placeholder="Наименование контрагента" isReadOnly {...txtCompanyName}
                                suffix={getInputButton('select', () => handlerOpenModalCompanies(true))}
                            />
                        </Flex>
                    </div>

                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.companyContactFIO ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Ф.И.О. контактного лица <p className="pulse"></p></Flex>
                            <Input placeholder="Ф.И.О. контактного лица" {...txtCompanyContactFIO}
                                suffix={txtCompanyContactFIO.value && getInputButton('clear', txtCompanyContactFIO.reset)}
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.companyContactPhone ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Телефон контактного лица <p className="pulse"></p></Flex>
                            <Input placeholder="Телефон контактного лица" {...txtCompanyContactPhone}
                                suffix={txtCompanyContactPhone.value && getInputButton('clear', txtCompanyContactPhone.reset)}
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.companyContactEmail ? 'input_error' : 'input_error input_error-active'}>
                            <Flex flexDirection="row" className="input_header">Email контактного лица</Flex>
                            <Input placeholder="Email контактного лица" {...txtCompanyContactEmail}
                                suffix={txtCompanyContactEmail.value && getInputButton('clear', txtCompanyContactEmail.reset)}
                            />
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>

            <Flex gap="5px" isRendered={guardianRequired.value === 1}>
                <Divider gap='6px' prefix={<h4>Родитель (Опекун)</h4>} />

                <Flex gap='15px'>
                    <div className={css['guardian_identity_row']}>
                        <Flex className={!fieldsError.value.guardianBirthDate ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Дата рождения <p className="pulse"></p></Flex>
                            <Input placeholder="Дата рождения" type='mask' mask='99.99.9999' {...txtGuardianBirthDate}
                                suffix={<>
                                    {txtGuardianBirthDate.value && getInputButton('clear', txtGuardianBirthDate.reset)}
                                    <SelectDate currentDate={txtGuardianBirthDate.value} onSelect={(date) => txtGuardianBirthDate.setValue(date)}>
                                        {getInputButton('calendar')}
                                    </SelectDate>
                                </>}
                            />
                        </Flex>

                        <Flex className={!fieldsError.value.guardianLastName ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Фамилия <p className="pulse"></p></Flex>
                            <Input placeholder="Фамилия" {...txtGuardianLastName}
                                suffix={txtGuardianLastName.value && getInputButton('clear', txtGuardianLastName.reset)}
                            />
                        </Flex>

                        <Flex className={!fieldsError.value.guardianFirstName ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Имя <p className="pulse"></p></Flex>
                            <Input placeholder="Имя" {...txtGuardianFirstName}
                                suffix={txtGuardianFirstName.value && getInputButton('clear', txtGuardianFirstName.reset)}
                            />
                        </Flex>

                        <Flex>
                            <Flex flexDirection="row" className="input_header">Отчество</Flex>
                            <Input placeholder="Отчество" {...txtGuardianSecondName}
                                suffix={txtGuardianSecondName.value && getInputButton('clear', txtGuardianSecondName.reset)}
                            />
                        </Flex>
                    </div>

                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.guardianPassport ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Паспортные данные <p className="pulse"></p></Flex>
                            <Textarea placeholder="ВНИМАНИЕ! Сначала введите серию и номер документа." rows={5}
                                value={txtGuardianPassport.value} onChange={(event) => txtGuardianPassport.setValue(event.target.value)}
                            />
                        </Flex>
                    </Flex>

                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.guardianRegistrationAddress ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Адрес прописки <p className="pulse"></p></Flex>
                            <ListenerAddressInput
                                value={txtGuardianRegistrationAddress.value}
                                onChange={txtGuardianRegistrationAddress.setValue}
                                label="Адрес прописки родителя (опекуна)"
                                loadSuggestions={getContractGuardianAddressSuggestions}
                            />
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>

            <Flex gap="5px" isRendered={cardMode === 'edit'}>
                <Divider gap='6px' prefix={<h4>Программы и слушатели</h4>} suffix={<Flex flexDirection="row" gap="10px" alignItems="center" isRendered={txtContractTypeID.value === 2 || (txtContractTypeID.value === 1 && programsList.value.length === 0)}>
                    <Button id='tooltipBtnCreate' size="sm" variant="icon" onClick={() => handlerOpenModalProgram(true, 'new')}><IconAdd /></Button>
                </Flex>} />

                    <Table.Content isScrollVertical={false}>
                        {programsList.value && !programsList.value.length
                            ? <Empty image={imgEmty} title='Программы отсутствуют' size='60px' />
                            : programsList.value && programsList.value.map((item) => (
                                <Table.Row key={item.contractProgramID} padding="6px" className={css['row_program']} background='var(--background_primary)' onClick={() => handlerOpenModalProgram(true, 'edit', item.contractProgramID)}>
                                    <div style={{ gap: '4px', padding: '6px 6px 0px 6px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', textWrap: 'nowrap', overflow: 'hidden' }}>
                                        <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                            <p>{item.courseName} 👉 {CommonService.formatDuration(item.durationEducation, item.volumeHours < 250)} 👉 {CommonService.formatHours(item.volumeHours)} 👉 {item.price} ₽ 👉 ({item.dateEducationStart} - {item.dateEducationEnd})</p>
                                            <p style={{ opacity: '.8' }}>{item.documentTypeName} 👉 {item.requirementName}</p>
                                        </div>

                                        <div style={{ gap: '4px', display: 'flex' }}>
                                            <Button variant="icon" size="md" isRendered={txtContractTypeID.value === 2 || item.listenersList.length === 0}
                                                onClick={(e) => { handlerOpenModalListeners(true, item.contractProgramID, item.qualification); e.stopPropagation() }}
                                            ><IconListeners /></Button>

                                            <Button variant="icon" size="md" isRendered={item.listenersList.length === 0}
                                                onClick={(e) => {
                                                    handlerOpenModalConfirm(true, 'Удаление программы', 'Вы действительно хотите удалить данную программу?', 'deleteProgram', item.contractProgramID); e.stopPropagation()
                                                }}
                                            ><IconDelete /></Button>
                                        </div>
                                    </div>

                                    <Table.Content isScrollVertical={false}>
                                        {!item.listenersList.length
                                            ? <Empty image={imgEmty} title="Слушатели отсутствуют" color="#fff" size='60px' />
                                            : item.listenersList.map((listener) => (
                                                <Table.Row key={listener.contractListenerID} padding="6px" className={css['row_listener']} onClick={(e) => { handlerOpenModalListenerProperty(true, item.contractProgramID, listener.contractListenerID, item.documentTypeID, listener.attestationTypeID, listener.attestationTypeName, listener.qualification); e.stopPropagation() }}>
                                                    <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                                        <p>{`${listener.lastName} ${listener.firstName} ${listener.secondName || ''}`.trim()} 👉 {listener.attestationTypeName}</p>
                                                        <p style={{ opacity: '.8' }}>{listener.educationLevelName} 👉 {listener.qualification}</p>
                                                    </div>

                                                    <nav>
                                                        <Button variant="icon" size="md" onClick={(e) => {
                                                            handlerOpenModalConfirm(true, 'Удаление слушателя', `Вы действительно хотите удалить следующего слушателя?<br /><br />${listener.lastName} ${listener.firstName} ${listener.secondName}`, 'deleteListener', listener.contractListenerID); e.stopPropagation()
                                                        }}><IconDelete /></Button>
                                                    </nav>
                                                </Table.Row>
                                            ))
                                        }
                                    </Table.Content>
                                </Table.Row>
                            ))
                        }
                    </Table.Content>
            </Flex>

            <Flex gap="5px" isRendered={cardMode === 'edit'}>
                <Divider gap='6px' prefix={<h4>Оплаты</h4>} suffix={<Flex flexDirection="row" gap="10px" alignItems="center">
                    <b>Долг: <b style={{color: 'red'}}>{formatter.format(summDuty.value)}</b> ₽</b>
                    <Divider type="vertical" size="20px" />
                    <Button id='tooltipBtnCreate' size="sm" variant="icon" onClick={() => handlerOpenModalPayments(true, 'new')}><IconAdd /></Button>
                </Flex>} />

                <Flex gap="6px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                    <Table.Header paddingLeft="14px" paddingRight="60px" classNameContent={css['table_grid_columns_header']}>
                        <p style={{textAlign: 'center'}}>Номер<br />платежа</p>
                        <p style={{textAlign: 'center'}}>Сумма<br />платежа</p>
                        <p style={{textAlign: 'center'}}>Дата<br />платежа</p>
                        <p style={{textAlign: 'center'}}>Дата<br />создания</p>
                    </Table.Header>

                    <Table.Content isScrollVertical={false}>
                        {paymentsList.value && !paymentsList.value.length
                            ? <Empty image={imgEmty} size='60px' title='Оплаты отсутствуют' />
                            : paymentsList.value && paymentsList.value.map((item, index) => (
                                <Table.Row key={item.contractsPaymentID} className={css['table_grid_columns_content']} onClick={() => handlerOpenModalPayments(true, 'edit', item.contractsPaymentID, item.paymentNumber, item.paymentDate, item.paymentSum, item.paymentPayer, item.isReturn)}>
                                    <p style={{textAlign: 'center'}}>{item.paymentNumber}</p>
                                    <p style={{textAlign: 'center'}}>{formatter.format(item.paymentSum)} ₽</p>
                                    <p style={{textAlign: 'center'}}>{item.paymentDate}</p>
                                    <p style={{textAlign: 'center'}}>{moment(item.dateCreate).format('DD.MM.YYYY')}<br />{moment(item.dateCreate).format('HH:mm:ss')}</p>

                                    <Flex gap="2px" flexDirection="row" alignItems="center" justifyContent="center">
                                        <Button id='tooltipBtnDelete' variant="icon" size="md" onClick={(e) => {
                                            handlerOpenModalConfirm(true, 'Удаление оплаты', `Вы действительно хотите удалить оплату № ${item.paymentNumber}, сумма: ${formatter.format(item.paymentSum)}₽ ?`, 'deletePayment', item.contractsPaymentID); e.stopPropagation()
                                        }}><IconDelete /></Button>
                                    </Flex>
                                </Table.Row>
                            ))
                        }
                    </Table.Content>
                </Flex>
            </Flex>

            <Flex gap="5px">
                <Divider gap='6px' prefix={<h4>Комментарий</h4>} />
                <Textarea placeholder="Комментарий" rows={5} value={txtComment.value} onChange={(e) => txtComment.setValue(e.target.value)} />
            </Flex>
        </Flex>

        {/* <ToolTip anchorSelect="#tooltipBtnClear" content='Очистить' place="left" /> */}
        {/* <ToolTip anchorSelect="#tooltipBtnSelect" content='Выбрать' place="left" /> */}
        {/* <ToolTip anchorSelect="#tooltipBtnDelete" content='Удалить' place="left" /> */}
        {/* <ToolTip anchorSelect="#tooltipBtnCreate" content='Добавить' place="left" /> */}
        {/* <ToolTip anchorSelect="#tooltipBtnPostPayment" content='Кликните для изменения' place="bottom" /> */}
        {/* <ToolTip anchorSelect="#tooltipBtnGenContractNumber" content='Получить новый номер договора' place="left" /> */}

        {/* <ToolTip anchorSelect="#tooltipBtnDeleteProgram" content='Удалить программу' place="left" /> */}
        {/* <ToolTip anchorSelect="#tooltipBtnSelectListeners" content='Добавить слушателей' place="left" /> */}
    </>
}